import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { OtherService } from 'src/app/services/other.service';

import { ToastrService } from 'ngx-toastr';

import { AccountService } from 'src/app/services/account.service';

import { Router } from '@angular/router';

declare let $: any;


@Component({

  selector: 'app-home-marketers',

  templateUrl: './home-marketers.component.html',

  styleUrls: ['./home-marketers.component.css']

})

export class HomeMarketersComponent implements OnInit {

  bShowTemplate: boolean = false;

  mdl_Login: FormGroup = this._fb.group({

    // فرم ثبت نام

    strMobile: new FormControl('', Validators.required),

    strFullName: new FormControl('', Validators.required),

    strUserPassword: new FormControl('', Validators.required),

    _strUserPassword: new FormControl('', Validators.required),

    strAddress: new FormControl(''),

    strCompanyName: new FormControl(''),

    // فرم رمز یکبار مصرف

    iSystemUser: new FormControl(''),

    iOTP: new FormControl(''),

    // مد ثبت نام، لاگین

    bRegister: new FormControl(false),

    // مد رمز عبور یکبار مصرف

    bOTP: new FormControl(false),

  })

  constructor(

    private _other: OtherService,

    private _fb: FormBuilder,

    private _router: Router,

    private _service: AccountService) {

  }

  ngOnInit(): void {

    this._other.setTitle('تاکسی لون | کسب درآمد از سفرهای بین شهری');

    setTimeout(() => {

      this.bShowTemplate = true;

    }, 100);

  }

  ngOnDestroy() {

    this._other.setTitle('');


  }

  openAdd() {

    window.open(`taxilon/general`, '_blank');

  }

  reset_Password() {

    if (this.mdl_Login.get('strMobile')?.value.trim() == '') {

      return this._service.toastSwal('error', 'شماره موبایل را وارد کنید')

    }

    if (this.mdl_Login.get('strMobile')?.value.length != 11) {

      return this._service.toastSwal('error', 'شماره موبایل را به درستی وارد کنید')

    }

    else {

      this._service.partner_Reset_Password(this.mdl_Login.get('strMobile')?.value).subscribe((data: any) => {

        let res = JSON.parse(data.toString());

        if (res.iResult == 0) return this._service.toastSwal('error', res.strError);

        if (res.iResult == 1) return this._service.toastSwal('success', res.strError);

        if (!res.length) return this._service.toastSwal('error', '!در دریافت اطلاعات خطایی رخ داده است');

      })

    }

  }

  mdl_Switch() {

    this.mdl_Login.patchValue({

      strMobile: '',

      strFullName: '',

      strUserPassword: '',

      _strUserPassword: '',

      strAddress: '',

      strCompanyName: '',

      iSystemUser: '',

      iOTP: '',

      bRegister: !this.mdl_Login.get('bRegister')?.value,

      bOTP: false

    })

  }

  enforceMaxLength(event: Event, nextInput?: any): void {

    const input = event.target as HTMLInputElement;

    if (input.value.length > 1) {

      // Always take the last digit the user enters

      input.value = input.value.slice(-1);

    }

    if (nextInput && nextInput > 1) {

      var el = document.getElementById(`input${+nextInput - 1}`) as HTMLInputElement;

      el.focus();

      el.value = '';

    }

  }

  submit_form() {

    let model = this.mdl_Login.value;

    // اعتبار سنجی کد ارسال شده

    if (model.bOTP) {

      var el_1 = document.getElementById(`input${4}`) as HTMLInputElement;

      var el_2 = document.getElementById(`input${3}`) as HTMLInputElement;

      var el_3 = document.getElementById(`input${2}`) as HTMLInputElement;

      var el_4 = document.getElementById(`input${1}`) as HTMLInputElement;

      model.iOTP = (el_1.value + el_2.value + el_3.value + el_4.value)

      this._service.partner_OTP(this._other.stringNumberToNumber(model)).subscribe((data: any) => {

        let res = JSON.parse(data.toString());

        if (res.iResult == 0) return this._service.toastSwal('error', res.strError);

        this.mdl_Login.patchValue({

          bRegister: false,

          bOTP: false,

          strUserPassword: '',

          _strUserPassword: '',

        })

        this._service.toastSwal('success', this.mdl_Login.get('strFullName')?.value + ' عزیز، ثبت نام شما با موفقیت انجام شد ');

      })

    }

    //  ورود کاربر

    if (!model.bRegister && !model.bOTP) {

      if (model.strMobile.trim() == '' || model.strUserPassword.trim() == '') {

        return this._service.toastSwal('error', 'موارد الزامی را وارد کنید')

      }

      else {

        this._service.partner_Login(this._other.stringNumberToNumber(model)).subscribe((data: any) => {

          let res = JSON.parse(data.toString());

          if (res.iResult == 0) return this._service.toastSwal('error', res.strError);

          if (!res.length) return this._service.toastSwal('error', '!در دریافت اطلاعات خطایی رخ داده است');

          if (res[0].isTrial) {

            this.mdl_Login.patchValue({

              iSystemUser: res[0].iSystemUser,

              bRegister: true,

              bOTP: true,

            })

          }

          else {

            this._service.toastSwal('success', res[0].strFullName + '، همکار گرامی خوش آمدید');

            localStorage.setItem('db31a17f18d1a8a3l0ifrEz8abJb02', this._service.encrypt(JSON.stringify(res[0])));

            this._router.navigateByUrl('/partners/dashboard')

          }


        })

      }

    }

    //  ثبت نام

    if (model.bRegister && !model.bOTP) {

      if (model.strMobile.trim() == '' || model.strFullName.trim() == '' || model.strUserPassword.trim() == '' || model._strUserPassword.trim() == '') {

        return this._service.toastSwal('error', 'موارد الزامی را وارد کنید')

      }

      if (this.mdl_Login.get('strMobile')?.value.length != 11) {

        return this._service.toastSwal('error', 'شماره موبایل را به درستی وارد کنید')

      }

      if (model.strUserPassword != model._strUserPassword) {

        return this._service.toastSwal('error', 'رمز عبور و تکرار رمز عبور یکسان نمی باشند')

      }

      else {

        this._service.partner_Register(this._other.stringNumberToNumber(model)).subscribe((data: any) => {

          let res = JSON.parse(data.toString());

          if (res.iResult == 0) return this._service.toastSwal('error', res.strError);

          if (!res.length) return this._service.toastSwal('error', '!در دریافت اطلاعات خطایی رخ داده است')

          this.mdl_Login.patchValue({

            iSystemUser: res[0].iSystemUser,

            bRegister: true,

            bOTP: true,

          })

        })

      }

    }


  }

  filterNumericInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9۰-۹]/g, '')
  }

}
